import React from 'react';
import { useImage } from 'react-image';

const CustomImage = (props) => {
  const { url, alt } = props;
  const { src } = useImage({
    srcList: url,
  });

  return <img src={src} alt={alt} />;
};
CustomImage.whyDidYouRender = true;
CustomImage.displayName = 'CustomImage';

export default React.memo(CustomImage);
